import computed from './attrs/computed'
import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'
import watch from './attrs/watch'
import Autocomplete from 'vuejs-auto-complete'
import ListHeader from '@/components/ListHeader/Index'

export default {
  name: 'BoardingPlaces',
  computed,
  data,
  methods,
  mounted,
  watch,
  components: {
    Autocomplete,
    ListHeader
  }
}
